
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'
// nodejs library that concatenates classes
import classnames from "classnames";
import { createCategories } from "api/categoryApiCall";

// javascript plugin that creates nice dropzones for files
import Dropzone from "dropzone";
// reactstrap components
import {
    UncontrolledAlert,
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Container,
    Row,
    Col,
} from "reactstrap";


// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
// react plugin that creates an input with badges
import { useTranslation } from '../../../i18n/context';

Dropzone.autoDiscover = false;

function AddCategory() {
    const [sidenavOpen, setSidenavOpen] = React.useState(true);
    const [categoryName, setCategoryName] = React.useState(false);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);

    const [formData, setFormData] = useState([{ category_name: '' }]);
    const [error, setError] = useState(null);
    const { t } = useTranslation();


    const navigate = useNavigate();
    const toggleSidenav = (e) => {
        if (document.body.classList.contains("g-sidenav-pinned")) {
            document.body.classList.remove("g-sidenav-pinned");
            document.body.classList.add("g-sidenav-hidden");
        } else {
            document.body.classList.add("g-sidenav-pinned");
            document.body.classList.remove("g-sidenav-hidden");
        }
        setSidenavOpen(!sidenavOpen);
    };

    const handleInputChange = (index, e) => {
        const { name, value } = e.target;
        const updatedFormData = [...formData];
        updatedFormData[index][name] = value;
        setFormData(updatedFormData);
    };

    const addCategoryField = () => {
        setFormData([...formData, { category_name: '' }]);
    };

    const removeCategoryField = (index) => {
        const updatedFormData = formData.filter((_, i) => i !== index);
        setFormData(updatedFormData);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const [errorCategoriesCall, successCategoryCall] = await createCategories(formData);
        if (errorCategoriesCall || !successCategoryCall) {
            setError(errorCategoriesCall);
            setShowErrorAlert(true);
        } else {
            setShowSuccessAlert(true);
            setTimeout(() => {
                navigate('/admin/category');
            }, 2000);
        }
    };


    return (
        <>
            <SimpleHeader name={t('category.add_category')} />

            <Container className="mt--6" fluid>
                <Row>
                    <Col lg="12">
                        <div className="card-wrapper">
                            <Card>
                                <CardHeader>
                                    <h3 className="mb-0">{t('category.add_category')}</h3>
                                    {showSuccessAlert && (
                                        <UncontrolledAlert color="success">
                                            <span className="alert-icon">
                                                <i className="ni ni-like-2" />
                                            </span>
                                            <span className="alert-text ml-1">
                                                <strong>{t('profile.success')}</strong>{t('category.successful')}
                                            </span>
                                        </UncontrolledAlert>
                                    )}

                                    {showErrorAlert && (
                                        <UncontrolledAlert color="danger">
                                            <span className="alert-icon">
                                                <i className="ni ni-support-16" />
                                            </span>
                                            <span className="alert-text ml-1">
                                                <strong>{t('profile.error')}</strong>{t('category.not_successfull')}
                                            </span>
                                        </UncontrolledAlert>
                                    )}
                                </CardHeader>

                                <CardBody>
                                    <Form onSubmit={handleSubmit}>
                                        {formData.map((category, index) => (
                                            <Row key={index}>
                                                <Col md="10">
                                                    <FormGroup>
                                                        <InputGroup
                                                            className={classnames("input-group-merge", {
                                                                focused: categoryName,
                                                            })}
                                                        >
                                                            <InputGroupAddon addonType="prepend">
                                                                <InputGroupText>
                                                                    <i className="fas fa-tag" />
                                                                </InputGroupText>
                                                            </InputGroupAddon>
                                                            <Input
                                                                placeholder={t('category.category_name')}
                                                                type="text"
                                                                name="category_name"
                                                                value={category.category_name}
                                                                onChange={(e) => handleInputChange(index, e)}
                                                                required
                                                                onFocus={() => setCategoryName(true)}
                                                                onBlur={() => setCategoryName(false)}
                                                            />
                                                        </InputGroup>
                                                    </FormGroup>
                                                </Col>
                                                {index > 0 && (
                                                    <Col md="2">
                                                        <Button
                                                            color="danger"
                                                            onClick={() => removeCategoryField(index)}
                                                            disabled={formData.length === 1}
                                                        >
                                                            {t('category.remove')}
                                                        </Button>
                                                    </Col>
                                                )}

                                            </Row>
                                        ))}
                                        <Button color="primary" onClick={addCategoryField}>
                                            {t('category.add_another')}
                                        </Button>
                                        <Button className="btn-icon" color="primary" type="submit">
                                            <span className="btn-inner--text">{t('profile.submit')}</span>
                                        </Button>
                                    </Form>
                                </CardBody>
                            </Card>
                        </div>
                    </Col>
                </Row>
            </Container>
            {sidenavOpen ? (
                <div className="backdrop d-xl-none" onClick={toggleSidenav} />
            ) : null}
        </>
    );
}


export default AddCategory;
